import React from "react";
import { Check, MousePointerClick } from "lucide-react";
import { CardSurface } from "@/components/card/CardSurface";

const SAMPLE = {
  business: {
    namaPenuh: "Ahmad Zaki",
    jawatan: "Pengarah Urusan",
    namaPerniagaan: "Zaki Trading",
    bidangBisnes: "Pemborong dan Pengedar Barangan Runcit",
    telefon: "013-222 8899",
    email: "zaki@zakitrading.my",
  },
  businessAddress: {
    line1: "Lot 15, Jalan Lintas",
    postcode: "88300",
    city: "Kota Kinabalu",
    state: "Sabah",
    country: "Malaysia",
  },
};

export const DesignGallery = ({
  templates,
  selectedId,
  onSelect,
  sample = SAMPLE,
  compact = false,
  idPrefix = "",
}) => (
  <div
    className={`grid gap-5 sm:gap-6 ${
      compact ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
    }`}
    data-testid="design-gallery"
  >
    {templates.map((t) => {
      const selected = selectedId === t.template_id;
      return (
        <button
          key={t.template_id}
          type="button"
          onClick={() => onSelect(t.template_id)}
          aria-label={`Pilih design ${t.template_id} ${t.name}`}
          data-testid={`${idPrefix}btn-pilih-design-${t.template_id}`}
          className={`group relative block w-full text-left rounded-2xl p-3 sm:p-4 bg-white/70 border transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-[2px] hover:shadow-[0_10px_30px_-14px_rgba(15,63,47,0.35)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0F3F2F] ${
            selected
              ? "border-[#12876A] shadow-[0_10px_30px_-16px_rgba(15,63,47,0.4)]"
              : "border-[#0F3F2F]/10"
          }`}
        >
          <div
            className="relative overflow-hidden rounded-xl"
            data-testid={`${idPrefix}template-card-${t.template_id}`}
          >
            <CardSurface
              styleKey={t.style_key}
              side="front"
              data={sample}
              testId={`${idPrefix}template-thumb-${t.template_id}`}
              className="max-w-none w-full"
            />
            {/* desktop hover overlay */}
            <div className="hidden md:flex absolute inset-0 items-center justify-center rounded-xl bg-[#0B2A20]/55 opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 transition-opacity duration-200">
              <span className="rounded-full bg-white px-4 py-2 text-sm font-semibold text-[#0F3F2F] shadow-sm">
                Pilih Design Ini
              </span>
            </div>
          </div>

          <div className="mt-3 flex items-center justify-between gap-3">
            <div>
              <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#12876A]">
                {t.template_id}
              </p>
              <p className="text-base font-semibold tracking-tight text-slate-900">{t.name}</p>
            </div>
            {selected ? (
              <span className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-[#0F3F2F]">
                <Check strokeWidth={2} className="h-3.5 w-3.5" /> Dipilih
              </span>
            ) : (
              <span className="md:hidden inline-flex items-center gap-1 rounded-full border border-[#0F3F2F]/15 px-2.5 py-1 text-xs font-semibold text-[#0F3F2F]">
                <MousePointerClick strokeWidth={1.5} className="h-3.5 w-3.5" /> Pilih Design
              </span>
            )}
          </div>
        </button>
      );
    })}
  </div>
);
